import {isMobile} from '../../../../../../commons/selectors/environment'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {RsvpInfoButtonOwnProps, RsvpInfoButtonRuntimeProps} from './interfaces'
import {RsvpInfoButton as Presentation} from './rsvp-info-button'

const mapRuntime = ({state, actions: {navigateToMainPage}}: DetailsPageAppProps): RsvpInfoButtonRuntimeProps => ({
  mobile: isMobile(state),
  navigateToMainPage,
})

export const RsvpInfoButton = connect<RsvpInfoButtonOwnProps, RsvpInfoButtonRuntimeProps>(mapRuntime)(Presentation)
